import { IResourceList } from 'src/components/challenge/ChallengeInterfaces';
import { ResourceTypeDetailEnum } from 'src/shared/enums';
import { IExperienceActivator } from 'src/shared/models';

const {
  EXPERIENCE_ACTIVATION_BUTTON,
  EXPERIENCE_ACTIVATION_DESCRIPTION,
  EXPERIENCE_ACTIVATION_LINK_TITLE,
  EXPERIENCE_ACTIVATION_LINK_URL,
  EXPERIENCE_ACTIVATION_MODAL_DESCRIPTION,
  EXPERIENCE_ACTIVATION_MODAL_BUTTON,
} = ResourceTypeDetailEnum;

export const buildExperienceActivator = (
  resource: IResourceList
): IExperienceActivator => {
  const { resourceDetailList, idResource, name: title } = resource;
  let item: IExperienceActivator;

  resourceDetailList
    .filter(({ status }) => status)
    .forEach(({ idResourceTypeD: { idResourceTypeD }, value }) => {
      switch (idResourceTypeD) {
        case EXPERIENCE_ACTIVATION_BUTTON:
          item = {
            ...item,
            buttonLabel: value,
          };
          break;
        case EXPERIENCE_ACTIVATION_DESCRIPTION:
          item = {
            ...item,
            description: value,
          };
          break;
        case EXPERIENCE_ACTIVATION_LINK_TITLE:
          item = {
            ...item,
            linkLabel: value,
          };
          break;
        case EXPERIENCE_ACTIVATION_LINK_URL:
          item = {
            ...item,
            linkUrl: value,
          };
          break;
        case EXPERIENCE_ACTIVATION_MODAL_DESCRIPTION:
          item = {
            ...item,
            modalDescription: value,
          };
          break;
        case EXPERIENCE_ACTIVATION_MODAL_BUTTON:
          item = {
            ...item,
            modalButtonLabel: value,
          };
          break;
      }
    });

  return {
    ...item,
    idResource,
    title,
  };
};
